module.exports = __webpack_public_path__ + "static/media/HairBack_4.bff9040d.jpg";